import { useConfig, useSettings } from '@vmos2/providers';
import { useLocale } from '@vmos2/utils';
import { useTranslation } from 'react-i18next';

import { usePriceContext } from './priceProvider';
import { useCallback } from 'react';

interface Options {
  isNegative?: boolean;
  isPositive?: boolean;
}

export const usePriceAriaLabel = ({ isNegative = false, isPositive = false }: Options = {}) => {
  const config = useConfig();
  const priceContext = usePriceContext();
  const settings = useSettings();
  const { locale } = useLocale(config, settings);
  const { t } = useTranslation('common');

  const getAriaLabel = useCallback(
    (value: number) => {
      const price = new Intl.NumberFormat(locale, {
        currency: priceContext?.currency,
        minimumFractionDigits: 2,
        style: 'currency',
        useGrouping: false,
      }).format(value);

      let ariaLabel = '';

      if (isNegative) {
        ariaLabel += t('minus', { price });
      }

      if (isPositive) {
        ariaLabel += t('plus', { price });
      }

      return ariaLabel || price;
    },
    [isNegative, isPositive, locale, priceContext?.currency, t]
  );

  return getAriaLabel;
};
